import type { TableOptions } from '@tanstack/react-table';

import type { DataTableLoadingStateProps } from './loading-state-types.js';
import type { DataTableRowData } from '../../row-data-types.js';
import type { TDataTableFeatures } from '../types/features.types.js';

/** Progress circle height breakpoint (px). */
export const PROGRESS_CIRCLE_HEIGHT_BREAKPOINT = 120;

/**
 * Configuration hook for the DataTable LoadingState feature.
 * @internal
 */
export function useLoadingState<TData extends DataTableRowData>(
  props: DataTableLoadingStateProps,
  options: TableOptions<TDataTableFeatures, Exclude<TData, unknown>>,
): void {
  options.state = {
    ...options.state,
    loading: props.loading,
  };
}
